<section class="cases-section py-5" id="cases">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 mx-auto text-center mb-5">
        <h2 class="section-title">{{ i18n.getTranslation('cases.title') }}</h2>
        <p class="section-subtitle">{{ i18n.getTranslation('cases.subtitle') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4" *ngFor="let project of projects">
        <div class="case-card h-100">
          <div class="case-image">
            <img [src]="project.image" [alt]="project.title" class="img-fluid">
            <div class="case-overlay">
              <div class="case-actions">
                <button class="btn btn-light btn-sm me-2" (click)="viewProject(project)">
                  <i class="fas fa-eye me-1"></i>
                  View Details
                </button>
                <a [href]="project.liveUrl" target="_blank" class="btn btn-primary btn-sm" *ngIf="project.liveUrl">
                  <i class="fas fa-external-link-alt me-1"></i>
                  Live Demo
                </a>
              </div>
            </div>
          </div>
          <div class="case-content">
            <h4 class="case-title">{{ project.title }}</h4>
            <p class="case-description">{{ project.description }}</p>
            <div class="case-tech">
              <span class="badge bg-primary me-1 mb-1" *ngFor="let tech of project.technologies">
                {{ tech }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
